export const setOpenOrder = (value, page, limit, count) => {
    return {
      type: 'SET_OPENORDER',
      payload: { data: value, page, limit, count }
    };
  };